module.exports = __webpack_public_path__ + "static/media/25UNHCR2.f679a461.jpg";